import React, { Fragment, useState } from 'react';
import { Container } from 'react-bootstrap';
import HeaderLogged from '../../../../components/header_logged'
import Footer from '../../../../components/footer'
import Head from '../../../../components/head';
import Fundo from '../../../../components/auth/balanco/listar/form_fundo'


function FundoBalancoScreen() {

    return (
        <Fragment>
            <Head titulo="Editando Fundo - Módulo de Balanços" />
            <HeaderLogged />
            <Container>
               <Fundo />
            </Container>
            <Footer />
        </Fragment>
    );
}

export default FundoBalancoScreen;